import styled from 'styled-components'

export const RosterViewWrapper = styled.div`
  position: relative;
  .sortable_min-width {
    min-width: 80px;
  }
  .link-back {
    display: block;
    float: left;
    margin: 6px 26px 0 0;
  }

  .section-wrapper {
    padding: 45px 40px 45px 40px;

    &.section-wrapper--padding,
    &:last-child {
      margin: 30px 0;

      table {
        tr {
          td:nth-child(3) {
            text-transform: lowercase;

            &:first-letter {
              text-transform: capitalize;
            }
          }

          td:nth-child(4) {
            position: relative;

            & > * {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              margin: auto;
              left: 0;
              right: 0;
            }
          }

          td:last-child {
            text-align: right;

            & > div > * {
              display: block;
              float: left;

              svg {
                margin: 0;
              }
            }

            & > div > *:last-child {
              margin-left: 20px;
              margin-right: 59px;
            }
          }

          th:first-child,
          td:first-child {
            padding-left: 40px;
          }

          td:last-child {
            padding-right: 0;
            text-align: right;
          }

          th:last-child {
            text-align: right;
            padding-right: 60px;
          }
        }
      }
    }

    .negative-margin {
      margin: 0 -40px 0 -40px;
      flex-grow: 1;
      overflow-x: auto;
      width: 100%;
    }

    .row {
      margin: 0;
      div[class^='col-'] {
        padding: 0;
      }

      &:first-child {
        margin: 0 0 30px 0;
      }
    }

    .section-title {
      margin: 0 0 33px 0;
    }

    .section-label {
      margin: 0 0 10px 0;
    }

    &.mission-section-wrapper {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
    }
  }
`
